import OnboardLayout from '@/layouts/OnboardLayout.vue'

export default {
  path: '/',
  component: OnboardLayout,
  redirect: '/brand/login',
  children: [
    {
      path: '/brand/choose-profession',
      name: 'choose-profession',
      component: () => import('@/views/Brand/ChooseProfession.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Choose profession | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/industry-profession',
      name: 'industry-profession',
      component: () => import('@/views/Brand/IndustryProfession.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Industry Profession | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/primary-goal',
      name: 'primary-goal',
      component: () => import('@/views/Brand/PrimaryGoal.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Primary Goal | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/target-audience',
      name: 'target-audience',
      component: () => import('@/views/Brand/TargetAudience.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Target Audience | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/activities-interested',
      name: 'activities-interested',
      component: () => import('@/views/Brand/ActivitiesInterested.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Activities Interested | Brand',
        breadcrumb: 'Login'
      }
    },
    {
      path: '/brand/average-audience',
      name: 'average-audience',
      component: () => import('@/views/Brand/AverageAudience.vue'),
      meta: {
        requiresAuth: true,
        userType: 'brand',
        title: 'Average Audience | Brand',
        breadcrumb: 'Login'
      }
    },
  ]
}
